import { H6, Image } from '../../../../AbstractElements';
import { Card, CardBody, CardHeader, Col, Form, FormGroup, Input, Row, Spinner } from 'reactstrap';
import React, { Fragment, useState, useEffect } from 'react';
import bannerApi from '../../../../api/bannerAppCheckin';

const ProductSidebar = () => {
    const [sidebaron, setSidebaron] = useState(true);
    const [searchKeyword, setSearchKeyword] = useState('');
    const [bannerData, setBannerData] = useState(null);
    const [bannerLoading, setBannerLoading] = useState(true);

    // Load banner for sidebar
    useEffect(() => {
        const loadSidebarBanner = async () => {
            try {
                setBannerLoading(true);
                const response = await bannerApi.getAll();
                
                // Ensure we have an array based on actual API response format
                let bannersArray = [];
                if (response && response.success && response.data && Array.isArray(response.data.banners)) {
                    bannersArray = response.data.banners;
                } else if (Array.isArray(response)) {
                    bannersArray = response;
                } else if (response && Array.isArray(response.data)) {
                    bannersArray = response.data;
                } else if (response && Array.isArray(response.banners)) {
                    bannersArray = response.banners;
                } else if (response && response.result && Array.isArray(response.result)) {
                    bannersArray = response.result;
                } else {
                    console.warn('⚠️ Unexpected response format:', response);
                    bannersArray = [];
                }
                
                // Get first banner for sidebar display
                if (bannersArray.length > 0) {
                    setBannerData(bannersArray[0]);
                } else {
                    setBannerData(null);
                }
            } catch (err) {
                console.error('❌ Error loading sidebar banner:', err);
                setBannerData(null);
            } finally {
                setBannerLoading(false);
            }
        };

        loadSidebarBanner();
    }, []);

    const onClickFilter = () => {
        if (sidebaron) {
            setSidebaron(false);
            document.getElementById('product-wrapper').classList.add('sidebaron');
        } else {
            setSidebaron(true);
            document.getElementById('product-wrapper').classList.remove('sidebaron');
        }
    };

    const handleSearchKeyword = (keyword) => {
        setSearchKeyword(keyword);
        // Note: Search functionality removed since we're only showing banners
    };
    return (
        <Fragment>
            <Row>
                <Col xl="3" md="6">
                    <div className={`product-sidebar ${sidebaron ? 'open' : ''}`}>
                        <div className="filter-section">
                            <Card>
                                <CardHeader>
                                    <H6 attrH6={{ className: 'mb-0 f-w-600' }}>Banner Info
                                        <span className="pull-right">
                                            <i className="fa fa-chevron-down toggle-data"
                                                onClick={onClickFilter}>
                                            </i>
                                        </span>
                                    </H6>
                                </CardHeader>
                                <div className="left-filter">
                                    <CardBody className="filter-cards-view animate-chk">
                                        <div className="product-filter text-center mt-2">
                                            {bannerLoading ? (
                                                <div className="d-flex justify-content-center align-items-center" style={{ height: '150px' }}>
                                                    <Spinner size="sm" color="primary" />
                                                    <p className="mt-2 mb-0">Loading banner...</p>
                                                </div>
                                            ) : bannerData ? (
                                                <div>
                                                    <Image attrImage={{ 
                                                        className: 'img-fluid banner-product m-auto', 
                                                        src: bannerData.url, 
                                                        alt: bannerData.filename || 'Banner từ API',
                                                        onError: (e) => {
                                                            e.target.src = '/src/assets/images/dashboard/profile.png';
                                                        }
                                                    }} />
                                                    <div className="mt-2">
                                                        <small className="text-muted">
                                                            Banner #{bannerData.id}<br/>
                                                            Size: {(bannerData.size / 1024).toFixed(1)} KB
                                                        </small>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="text-center py-4">
                                                    <p className="text-muted">No banner available</p>
                                                </div>
                                            )}
                                        </div>
                                    </CardBody>
                                </div>
                            </Card>
                        </div>
                    </div>
                </Col>
                <Col xl="9" md="6">
                    <div className="product-search">
                        <Form>
                            <FormGroup className="m-0 form-group search-product">
                                <Input className="form-control" type="text" placeholder="Search banners..."
                                    defaultValue={searchKeyword}
                                    onChange={(e) => handleSearchKeyword(e.target.value)} />
                                <i className="fa fa-search"></i>
                            </FormGroup>
                        </Form>
                    </div>
                </Col>
            </Row>
        </Fragment>
    );
};
export default ProductSidebar;